export type errorObjectType = {
  firstNameError: boolean ;
  lastNameError: boolean;
  emailIncorrectError: boolean;
  emailBlankError: boolean;
  phoneBlankError: boolean;
  phoneIncorrectError: boolean;
};

export type conditionStateType = {
  loginComponent: boolean;
  loginCheck: boolean;
  disableCheck: boolean;
  agentForm: boolean;
  customerForm: boolean;
  actionError: boolean;
  validationCheck: boolean;
};

export type formObjectType = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
};
export type payload = {
  email?: string;
  phoneNumber?: string;
  requestType?: string;
  uuid?: string;
  action?: string;
  attributes?: {
    customerAgentInfo: {customer: formObjectType;
    agent?: formObjectType;};
  };
  deferred?: {};
  clientTokenType?: string;
  clientToken?: string;
  // eslint-disable-next-line camelcase
  device_type?: string;
  site?: string;
};
export type actionSubjectObjectType = { actionValue: string; subjectValue: string };

export const customerInputArray = [
  { name: 'firstName', placeHolder: 'First Name' },
  { name: 'lastName', placeHolder: 'Last Name' },
  { name: 'email', placeHolder: 'Email' },
  { name: 'phone', placeHolder: 'Phone Number' }
];

export const conditionState: conditionStateType = {
  loginComponent: false,
  loginCheck: false,
  disableCheck: false,
  agentForm: false,
  customerForm: false,
  actionError: false,
  validationCheck: false
};
export const formObject: formObjectType = {
  firstName: '',
  lastName: '',
  email: '',
  phone: ''
};
export const errorObject: errorObjectType = {
  firstNameError: false,
  lastNameError: false,
  emailIncorrectError: false,
  emailBlankError: false,
  phoneBlankError: false,
  phoneIncorrectError: false
};
export const SubmitButtonClassVlaue = 'base-button base-button--full-width regulatory-updates-modal__btn sj-button base-button--activation';
export const SubmitButtonDisabledClassVlaue = 'base-button base-button--full-width regulatory-updates-modal__btn sj-button base-button--activation base-button--disabled';
// eslint-disable-next-line no-useless-escape
export const emailRegex = /^((?!^\.)(?!.*\.{2})([\w!#$%&'*+\-\/=?\^`.{|}~]*)[^.\s<>(),:;"@[\]])@(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})$/i;
// eslint-disable-next-line no-useless-escape
export const phoneRegex = /^(1\s|1|)?((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/;
